import { IAstNode } from './typings';
import { TypeGenerator } from '../utils/type';


function generatorType(type: string, isArray = false) {
  try {
    return (TypeGenerator as any)[type + (isArray ? 'Array' : '')]();
  } catch (err) {
    return TypeGenerator.create(type, { isArray });
  }
}

export function inferenceAtomNode(astNode: IAstNode) {

  const tokenType = astNode.token.type;
  const isDeclaration = astNode.token.isDeclaration;
  if (isDeclaration) {
    const { /** declaration, */ isArray = false } = astNode.token;
    // if (declaration === 'CURRENT_MEMBER_POINT') {
    //   return TypeGenerator.Number();
    // }
    // if (declaration === 'CURRENT_MEMBER_GRADE') {
    //   return TypeGenerator.Id();
    // }
    return generatorType(tokenType, isArray);
  }

  if (tokenType === 'FqnProperty') {
    const { type, options, fqn, ownerFqn, path } = astNode.token.fqn;
    const isArray = astNode.token.raw.includes('[]');
    if (['Enum'].includes(type)) {
      return !isArray ?
        TypeGenerator.Enum({ options, fqn, ownerFqn: fqn, path }) :
        TypeGenerator.EnumArray({ options, fqn, ownerFqn: fqn, path });
    } else if (['Id'].includes(type)) {
      const opts = { ownerFqn, path };
      return !isArray ?
        TypeGenerator.Id(opts) :
        TypeGenerator.IdArray(opts);
    } else if (['String'].includes(type)) {
      const opts = { ownerFqn, path };
      return !isArray ?
        TypeGenerator.String(opts) :
        TypeGenerator.StringArray(opts);
    }
    return generatorType(type, isArray);
  }

  if (tokenType === 'ModelProperty') {
    const { type, options, fqn, ownerFqn, path } = astNode.token.field;
    const isArray = astNode.token.raw.includes('[]');

    if (['Enum'].includes(type)) {
      return !isArray ?
        TypeGenerator.Enum({ options, fqn, ownerFqn: fqn, path }) :
        TypeGenerator.EnumArray({ options, fqn, ownerFqn: fqn, path });
    } else if (['Id'].includes(type)) {
      const opts = { ownerFqn, path };
      return !isArray ? TypeGenerator.Id(opts) :
        TypeGenerator.IdArray(opts);
    } else if (['String'].includes(type)) {
      const opts = { ownerFqn, path };
      return !isArray ?
        TypeGenerator.String(opts) :
        TypeGenerator.StringArray(opts);
    }
    return generatorType(type, isArray);
  }

  if (tokenType === 'CustomProperty') {
    const { dataType, options, fqn, ownerFqn } = astNode.token.property;
    const isArray = dataType.includes('Array');
    if (['Enum', 'EnumArray'].includes(dataType)) {
      return !isArray ?
        TypeGenerator.Enum({ options, fqn, ownerFqn: fqn }) :
        TypeGenerator.EnumArray({ options, fqn, ownerFqn: fqn });
    } else if (['Id', 'IdArray'].includes(dataType)) {
      const options = { ownerFqn };
      return !isArray ?
        TypeGenerator.Id(options) :
        TypeGenerator.IdArray(options);
    } else if (['String', 'StringArray'].includes(dataType)) {
      const options = { ownerFqn };
      return !isArray ?
        TypeGenerator.String(options) :
        TypeGenerator.StringArray(options);
    }
    return generatorType(dataType.replace('Array', ''), isArray);
  }

  if (tokenType === 'Placeholder') {
    return astNode.token.placeholder.dataType;
  }


  return generatorType(tokenType, false);
}
